import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MerchantBasicComponent} from './merchant-master/merchant-basic/merchant-basic.component';
import {MerchantAddComponent} from './merchant-master/merchant-add/merchant-add.component';
import {MerchantEditComponent} from './merchant-master/merchant-edit/merchant-edit.component';
import {MerchantMasterComponent} from "./merchant-master/merchant-master.component";
import {MerchantKycUploadComponent} from "./merchant-master/merchant-kyc-upload/merchant-kyc-upload.component";
import {SidebarComponent} from "../../layout/sidebar/sidebar.component";

import { MerchantstatusComponent } from './merchant-master/merchantstatus/merchantstatus.component';

import { MerchantsComponent } from './merchants.component';
import { MerchantCreateComponent } from './merchant-master/merchant-create/merchant-create.component';
import { PepComponent } from '../pep/pep.component';
import { RiskRegisterComponent } from '../risk-register/risk-register.component';
import { MerchantReportComponent } from '../merchant-report/merchant-report.component';
import { MerchantSummaryComponent } from '../merchant-summary/merchant-summary.component';
import { LeadmasterlistComponent } from '../leadmasterlist/leadmasterlist.component';
import { LeadreportComponent } from '../leadreport/leadreport.component';
//import { MerchantSummaryComponent } from '../merchant-summary/merchant-summary.component';

const routes: Routes = [
  {
    path: '',
    component: MerchantMasterComponent,
    children: [
      {
        path: '',
        redirectTo: 'merchant-master',
        pathMatch: 'full'
      },
      {
        path: 'merchant-master',
        data: { breadcrumb: {alias: 'Merchant.Agent Master'} },
        component: MerchantMasterComponent
      },   
     ]
  },
  {
    path: 'merchant-create',
    data: { breadcrumb: {alias: 'Merchant Create'} },
    loadChildren: () => import('./merchant-master/merchant-create/merchant-create.module').then(m => m.MerchantCreateModule)
  },
  {
    path: 'merchant-creation',
    data: { breadcrumb: {alias: 'Merchant Add'} },
    loadChildren: () => import('./merchant-master/merchant-creation/merchant-creation.module').then(m => m.MerchantCreationModule)
  },
  {
    path: 'merchant-kyc-upload',
    data: { breadcrumb: {alias: 'Kyc Upload'} },
    component: MerchantKycUploadComponent
  },
  {
    path: 'merchant-basic',
    data: { breadcrumb: {alias: 'Basic Setup'} },
    component: MerchantBasicComponent
  },
  {
    path: 'merchant-edit',
    data: { breadcrumb: {alias: 'Merchant Edit'} },
    component: MerchantEditComponent
  },
  {
    path: 'merchant-add',
    data: { breadcrumb: {alias: 'Merchant Add'} },
    component: MerchantAddComponent
  },
  {
    path: 'merchant-status',
    component: MerchantstatusComponent
  },
  {
    path: 'merchants',
    component: MerchantsComponent
  },
  {
    path: 'banklive',
    component: MerchantCreateComponent
  },
  // {
  //   path: 'pep',
  //   component: PepComponent 
  // } ,
  {
    path: 'riskRegister',
    component: RiskRegisterComponent 
  },
  {
    path: 'merchantReport',
    component: MerchantReportComponent 
  } ,
  {
    path: 'merchantSummary',
    component: MerchantSummaryComponent  
  } ,
  {
    path: 'leadreport',
    component: LeadmasterlistComponent
  } 
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [SidebarComponent]
})
export class MerchantListRoutingModule {
}
